export default {
  'menu.welcome': '工作台',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': '数据看板',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.dashboard.comicRankings': '漫画榜单',
  'menu.dashboard.packageMetrics': '按包统计',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
  'menu.tags': '标签管理',
  'menu.tags.source': '标签管理',
  'menu.tags.master': '主标签',
  'menu.tags.translations': '标签翻译',
  'menu.comics': '漫画管理',
  'menu.comics.list': '漫画列表',
  'menu.comics.recommended': '首页推荐',
  'menu.comics.works': '聚合漫画',
  'menu.comics.exports': '导出管理',
  'menu.comics.reportAnalysis': '报表分析',
  'menu.comics.retentionAnalysis': '留存分析',
  'menu.comics.spiderSync': 'Spider 同步',
  'menu.comics.edit': '编辑漫画',
  'menu.comics.chapters': '章节管理',
  'menu.comics.chapterEdit': '编辑章节',
  'menu.logs': 'App 用户',
  'menu.logs.blacklist': 'App 用户',
  'menu.logs.blackRecords': '黑名单记录',
  'menu.logs.searchRecords': '搜索记录',
  'menu.logs.comicPushDeliveries': '漫画推送记录',
  'menu.logs.whitelist': '白名单列表',
  'menu.logs.userPolicies': '用户策略',
  'menu.logs.userPolicyHits': '策略命中记录',
  'menu.versionManagement': '版本管理',
  'menu.versionManagement.version': '版本管理',
  'menu.versionManagement.ips': 'IP管理',
  'menu.versionManagement.packages': '包管理',
  'menu.growthConfig': '增长配置',
  'menu.growthConfig.adConfig': '广告配置',
  'menu.growthConfig.adConfig.adManagement': '广告管理',
  'menu.growthConfig.adConfig.adManagement.adSlotsConfig': '广告组',
  'menu.growthConfig.adConfig.adManagement.adGlobalConfigs': '全局广告配置',
  'menu.growthConfig.adConfig.adIds': '广告ID管理',
  'menu.growthConfig.adConfig.adTypes': '广告类型',
  'menu.growthConfig.adConfig.adSlotPositions': '广告位',
  'menu.growthConfig.adConfig.adClientPositions': '客户端位置',
  'menu.growthConfig.adConfig.adSlotPlacementSettings': '广告位全局设置',
  'menu.growthConfig.adExperiments': 'A/B Testing',
  'menu.growthConfig.homeGuide': '首页引导位',
  'menu.growthConfig.appDecor': '装修管理',
  'menu.growthConfig.appDecor.profiles': '装修方案',
  'menu.growthConfig.appDecor.pools': '漫画池',
  'menu.growthConfig.appDecor.comicLists': '漫单管理',
  'menu.growthConfig.appDecorProfiles': '装修方案',
  'menu.growthConfig.feedbacks': '用户反馈',
  'menu.growthConfig.feedbacks.settings': '设置页反馈',
  'menu.growthConfig.feedbacks.readerUser': '阅读器反馈',
  'menu.growthConfig.feedbacks.summary': '漫画反馈-汇总',
  'menu.growthConfig.namespaces': '命名空间',
  'menu.configManagement': '全局配置',
  'menu.configManagement.featureFlags': 'Feature Flag',
  'menu.configManagement.lab': '实验室',
  'menu.system': '系统管理',
  'menu.maintenance': '维护管理',
  'menu.maintenance.readerBugs': 'BUG 管理',
  'menu.system.users': '后台用户',
  'menu.system.groups': '账号组权限',
  'menu.system.permissions': '权限目录',
  'menu.system.actionLogs': '操作审计',
  'menu.system.flower': '任务监控',
  'menu.system.cache': '缓存管理',
  'menu.system.encryptedDomains': '混淆域名',
  'menu.system.policyGatewayTestRoutes': '策略网关测试转发',
  'menu.system.notificationBridge': '通知桥接',
};
